import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { DimensionScore } from '../utils/scoring';
interface MaturityRadarProps {
  data: DimensionScore[];
}
export function MaturityRadar({
  data
}: MaturityRadarProps) {
  // Transform data for Recharts
  const chartData = data.map(d => ({
    subject: d.dimension,
    A: d.score,
    fullMark: 5
  }));
  return <div className="w-full h-[300px] md:h-[400px]" data-id="element-8">
      <ResponsiveContainer width="100%" height="100%" data-id="element-9">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={chartData} data-id="element-10">
          <PolarGrid stroke="#e2e8f0" data-id="element-11" />
          <PolarAngleAxis dataKey="subject" tick={{
          fill: '#475569',
          fontSize: 12,
          fontWeight: 500
        }} data-id="element-12" />
          <PolarRadiusAxis angle={30} domain={[0, 5]} tick={false} axisLine={false} data-id="element-13" />
          <Radar name="Maturidade" dataKey="A" stroke="#0f172a" strokeWidth={3} fill="#0f172a" fillOpacity={0.2} data-id="element-14" />
          <Tooltip contentStyle={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
        }} itemStyle={{
          color: '#0f172a',
          fontWeight: 'bold'
        }} data-id="element-15" />
        </RadarChart>
      </ResponsiveContainer>
    </div>;
}